'use client';
import { ProductCardContext } from '.';
import { cva, VariantProps } from 'class-variance-authority';
import { useContext } from 'react';
import { prefabsStore } from '@/shared/ui/modal/prefabs-store';
import { Tags } from '@/shared/ui/tags';
import { ProductCardProps } from './types';

const TEST_ID = 'product-card-tags';

const productCardTagsVariants = cva(null, {
    variants: {
        variant: {
            inImage: 'product-card__image-tags',
            default: undefined,
        },
    },
});

type Props = Partial<Pick<ProductCardProps, 'tags'>> & VariantProps<typeof productCardTagsVariants>;
export const ProductCardTags = ({ tags, variant = 'default' }: Props) => {
    const context = useContext(ProductCardContext);

    const finalTags = tags ?? context.tags;

    if (!finalTags) {
        return null;
    }

    // Placement is JSON-config driven (default: outline pills below the image, per design).
    const settings = prefabsStore.getProductTags();
    const isOverImage = (settings?.placement ?? 'belowImage') === 'overImage';
    const appearance = settings?.appearance ?? 'outline';

    // Each card variant renders this component in both the in-image and below-image slots;
    // render only the slot matching the configured placement to avoid duplicate tags.
    if (variant === 'inImage' && !isOverImage) {
        return null;
    }
    if (variant !== 'inImage' && isOverImage) {
        return null;
    }

    if (variant === 'inImage') {
        return (
            <Tags
                tags={finalTags}
                appearance={appearance}
                data-testid={TEST_ID}
                className={'product-card__image-tags'}
            />
        );
    }

    return <Tags tags={finalTags} appearance={appearance} data-testid={TEST_ID} />;
};
